import { useContext } from 'react';

import { GlobalCacheContext } from '@app/contexts/GlobalCacheContext';

export function useGlobalCache() {
  return useContext(GlobalCacheContext);
}
